import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Survey from 'pages/survey/Survey';

const SurveyRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Survey />} />
    </Routes>
  );
};

export default SurveyRouter;
